import React, { Component } from "react";
import JCAHOseal from "../images/JCAHOgold-seal.jpg"
class JCAHO extends Component {
    render() {
      return (
        <>
        <div class="center">
        <img src={JCAHOseal} alt="jcahoseal" class="center"/>
        </div>
        <p align="center">The Endoscopy Center of Central Pennsylvania, L.L.C.</p>
        <p align="center">is proudly</p>
        <p align="center"><b><font size="6">Accredited</font></b></p>
        <p align="center">by the</p>
        <p align="center">Joint Commission on Accreditation of Healthcare Organizations</p>
        <p align="center">&nbsp;</p>
        <p align="center"><a className="blueLink" href="http://www.jointcommission.org/">Link
        to JCAHO website</a></p>
        <p className="MsoNormal" align="center">The public may contact the Joint
        Commission's Office of Quality Monitoring to report any concerns or register
        complaints about a Joint Commission-accredited health care organization by
        either calling 1-800-994-6610 or by emailing complaint@jointcommission.org.</p>

        </>
      );
    }
  }
   
  export default JCAHO;